import {createAction} from "@reduxjs/toolkit";

const updateDetails = createAction("calculation/update-details")
export default updateDetails
